import api from './client';

export const getDiagrams    = (projectId) => api.get('/gantt-diagrams', { params: { project: projectId } });
export const createDiagram  = (data) => api.post('/gantt-diagrams', data);
export const renameDiagram  = (id, name) => api.put(`/gantt-diagrams/${id}`, { name });
export const deleteDiagram  = (id) => api.delete(`/gantt-diagrams/${id}`);
